import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { AuthenticationService } from '../../../shared/services/authentication.service';

@Component({
  selector: 'app-pda-inventory',
  templateUrl: './pda-inventory.component.html',
  styleUrls: ['./pda-inventory.component.scss']
})
export class PdaInventoryComponent implements OnInit {
  title: string;

  constructor(private location: Location,  
    public _authService: AuthenticationService
  ) { }

  ngOnInit(): void {}

  goBack(): void {
    this.location.back();
  }
}



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/pda/inventory/pda-inventory.component.ts